import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Shield } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface DMZNodeData {
  id: string;
  label: string;
  firewallRules?: number;
}

interface DMZNodeProps {
  data: DMZNodeData;
  selected: boolean;
}

export const DMZNode = memo(({ data, selected }: DMZNodeProps) => {
  return (
    <>
      <Card className={`min-w-[180px] ${selected ? 'ring-2 ring-primary shadow-lg' : ''}`}>
        <div className="p-3 bg-gradient-to-br from-red-50 to-rose-50 dark:from-red-950 dark:to-rose-950 border-l-4 border-red-500">
          <div className="flex items-center gap-2">
            <Shield className="h-5 w-5 text-red-600 dark:text-red-400" />
            <div className="flex-1">
              <div className="font-semibold text-sm">{data.label}</div>
              {data.firewallRules !== undefined && (
                <div className="text-xs text-muted-foreground">{data.firewallRules} rules</div>
              )}
            </div>
          </div>
        </div>
      </Card>

      {/* 4 bidirectional handles - isConnectableStart + isConnectableEnd allow both directions */}
      <Handle id="top" type="source" position={Position.Top} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-red-600 bg-red-200 dark:bg-red-800" />
      <Handle id="left" type="source" position={Position.Left} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-red-600 bg-red-200 dark:bg-red-800" />
      <Handle id="right" type="source" position={Position.Right} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-red-600 bg-red-200 dark:bg-red-800" />
      <Handle id="bottom" type="source" position={Position.Bottom} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-red-600 bg-red-200 dark:bg-red-800" />
    </>
  );
});

DMZNode.displayName = 'DMZNode';
